import React from 'react'

const StepButton = ({ active, isValid, title, stepIndex, totalSteps, setStep }) => {
    return (
        <button
        className={(active ? 'active ' : ' ') + (isValid === false ? 'step-invalid' : '')}
        // onClick={() => setStep(stepIndex)}
        aria-invalid={!isValid}
        >
        <div className={isValid ? 'step-check step-valid' : 'step-check'}>
            {isValid === false && <div className="invalid-icon" />}
        </div>
        <div>
            {title}
        </div>
        <span className="visually-hidden">{`Step ${stepIndex + 1} of ${totalSteps}`}{isValid === false ? "There are errors on this step" : ""}</span>
        </button>
        )
    }

export default StepButton;